// extracted by mini-css-extract-plugin
export default {"container":"input_container__NqOFB","title":"input_title__Qc23W"};